/***
 * @file: ä¸»é¢é¢è²çæä»¤ï¼ å°æ¥æéæ©æ¡çè¾¹æ¡è²è®¾ç½®ä¸ºä¸»é¢è²
 * @Date: 2020-07-01 14:27:39
 * @author: manyao.zhu
 */
import { AfterViewInit, Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

import { SettingsService } from '@ithinkdt/shared/browser';

@Directive({
  selector: '[dtColor]',
})
export class DatePickerBorderLineDirective implements AfterViewInit, OnChanges {
  @Input() dtColor;
  oldColor = '#d9d9d9'; // åæ¥çé¢è²
  color; // å¨å±çé¢è²
  constructor(private $element: ElementRef, private settingSrv: SettingsService) {}

  ngAfterViewInit() {
    this.color = this.settingSrv.layout['color']
      ? this.settingSrv.layout['color']['color']
      : this.settingSrv.userConfig['theme']['defaultColor'] || '';
    setTimeout(() => {
      this.setBorderColor();
    }, 1000);
  }

  ngOnChanges(sc: SimpleChanges) {
    if (sc['dtColor'] && sc['dtColor']) {
      setTimeout(() => {
        this.setBorderColor();
      }, 1000);
    }
  }

  setBorderColor() {
    const dom = this.$element.nativeElement;
    const input = dom.querySelector('.ant-input');
    const select = dom.querySelector('.ant-calendar-picker-icon');
    const remove = dom.querySelector('.ant-calendar-picker-clear');
    this.handleSelectDate(select, input);
    if (this.dtColor) {
      this.handleSelectDate(remove, input);
    }
  }

  // å¤çéæ©/ç§»é¤æ¥æçäºä»¶
  handleSelectDate(dom1, dom2) {
    dom1.onmouseenter = () => {
      dom2.style.borderColor = this.color;
      dom2.style.boxShadow = 'none';
    };
    dom1.onmouseleave = () => {
      dom2.style.borderColor = this.oldColor;
    };
  }
}
